import React from 'react';
import { BaseIcon } from 'components';

export const BrandIcon = (props) => {
  return (
    <BaseIcon props={props} className={`brand-icon ${props.className || ''}`}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 10">
        <path fill="#fff" fillRule="evenodd" d="M0 10h19V8.125h-5.6204L19 1.83915V0H.035316v1.875H5.61524L.035316 8.125H0V10zm15.9628-8.125H8.6119l-5.57992 6.25h7.35092l5.5799-6.25z" clipRule="evenodd"/>
      </svg>
    </BaseIcon>
  )
};
